import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormCheckField, {
  MxFormCheckFieldProps
} from "@rf-l2/form/text-fields/MxFormCheckField";

interface MxFormL3CheckFieldProps extends MxFormCheckFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3CheckField = (props: MxFormL3CheckFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormCheckField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3CheckField;
